var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "departBox" },
    [
      _vm.member
        ? _c("select-member", {
            staticStyle: { width: "100%" },
            attrs: {
              onlyOne: _vm.departType == "oneself" ? true : false,
              value: _vm.memberList || [],
            },
            on: { getSelectList: _vm.getSelectList },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.member
        ? _c("select-department", {
            staticStyle: { width: "100%" },
            attrs: {
              onlyOne: _vm.departType == "oneself" ? true : false,
              value: _vm.activeMastart || [],
            },
            on: { changeMastart: _vm.changeMastart },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }